import { useEffect, useState } from "react";
import { OVAMX_LOGO } from "@/lib/brand";

const links = [
  { label: "Manifiesto", href: "#manifiesto" },
  { label: "Feed Dual", href: "#feed" },
  { label: "Monetización", href: "#monetizacion" },
  { label: "IA & Viajes", href: "#ia" },
  { label: "Privacidad", href: "#privacidad" },
  { label: "Visión", href: "#vision" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-cream/75 backdrop-blur-xl border-b hairline"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          className="flex items-center gap-2.5 group"
        >
          <img src={OVAMX_LOGO} alt="Ovamx" className="w-9 h-9 md:w-10 md:h-10 rounded-lg object-contain" />
          <span className="font-serif text-3xl md:text-4xl tracking-tighter leading-none">
            Ovamx
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink-mid mt-1 hidden sm:inline">
            / 2026
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9 text-sm">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s|&/g, "-")}`}
              className="link-underline text-ink/80 hover:text-ink transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#cta"
          data-testid="header-cta-beta"
          className="inline-flex items-center gap-2 bg-ink text-cream px-5 md:px-6 py-2.5 md:py-3 rounded-full text-sm hover:bg-coral transition-colors duration-500"
        >
          Únete a la beta
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14M13 5l7 7-7 7" />
          </svg>
        </a>
      </div>
    </header>
  );
}
